import { render, staticRenderFns } from "./AccountChangePass.vue?vue&type=template&id=4ad5e175&"
import script from "./AccountChangePass.vue?vue&type=script&lang=js&"
export * from "./AccountChangePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports